import { gsap } from "gsap/all";
import Swup from 'swup';
import SwupJsPlugin from '@swup/js-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupGiaPlugin from '@swup/gia-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import DebugPlugin from '@swup/debug-plugin';
import components from './components'

export default class pageTransition {
  
  
  constructor() {}
  
  static init() {
    
    const transitions = [{
        from: '(.*)',
        to: '(.*)',
        in: function (next) {
          
          const tl = gsap.timeline({
            onComplete: next,
            defaults: {
              duration: 0.5,
            }
          })
          tl
            .from('#content', { opacity: 0, y: -200 })
        },
        out: (next) => {
          jQuery('.hustle-ui').fadeOut();
          
          const tl = gsap.timeline({
            onComplete: next,
            defaults: {
              duration: 0.5,
            }
          })
          tl
            .to('#content', { opacity: 0, y: -200 })
          
        }
      },
      {
        from: '(.*)',
        to: '/wp-content/uploads/:year/:month/(.*)',
        in: function (next) {
          next;
        },
        out: (next) => {
          next;
        }
      },
    ];
    
    const options = {
      animateHistoryBrowsing: true,
      plugins: [
        new SwupScriptsPlugin({
          optin: true
        }),
        new SwupJsPlugin(transitions),
        new SwupBodyClassPlugin(),
        new SwupGiaPlugin({ components }),
        // new DebugPlugin()
      ]
    }
    
    const swup = new Swup(options)
    swup.on('transitionStart', this.toTop);
    swup.on('contentReplaced', this.rerun);
    swup.on('contentReplaced', this.forminatorLoad);
    
  }
  
  static toTop() {
      window.scrollTo(0, 0);
  }
  
  static forminatorLoad() {
    var _forminator_scripts = jQuery('#swup').find('.wpmudev-forminator-data-script');
    if (_forminator_scripts.length) {
      _forminator_scripts.each(function () {
        let js_data = jQuery(this).data();
        if (js_data) {
          window.ForminatorFront = window.ForminatorFront || js_data.forminatorFront;
          window.datepickerLang = window.datepickerLang || js_data.datepicker_data;
          forminator_load_js(js_data);
          jQuery(this).remove();
        }
      });
      
      function forminator_load_js(js_data) {
        if (!js_data.js.length) {
          return jQuery('#swup').find('#forminator-module-' + js_data.args['id'] + '[data-forminator-render="' + js_data.args['render_id'] + '"]').forminatorLoader(js_data.args);
        }
        let jslib = js_data.js.shift();
        if (jslib) {
          jQuery.getScript(jslib, function () {
            if (!js_data.js.length) {
              // jQuery.each(js_data.ids, function(form_id, js_data.args){
              jQuery('#swup').find('#forminator-module-' + js_data.args['id'] + '[data-forminator-render="' + js_data.args['render_id'] + '"]').forminatorLoader(js_data.args);
              // });
            }
            else {
              forminator_load_js(js_data);
            }
          });
        }
      }
    }
  }
  
  static rerun() {
    const currentPage = window.location.pathname;
    if (currentPage.includes('contact')) {
      location.reload();
      return false;
    }
    
    
    //forminator
    const forminatorDiv = document.querySelectorAll('div.forminator_ajax');
    const forminator = document.querySelectorAll('form.forminator_ajax');
    if (forminator.length > 0) {
      forminator.forEach(el => {
        el.style.display = 'flex'
      })
    }
    if (forminatorDiv.length > 0) {
      forminatorDiv.forEach(el => {
        el.style.display = 'none'
      })
    }
    
    // console.log('forminator', jQuery('script[src*="forminator-form"]'));
    // jQuery('script[src*="forminator"]').remove().appendTo('html');
    
    
    //if asl js libraries are already in dom
    //remove them, reattach them
    if (jQuery('script[src*="agile-store-locator"]').length < 2) {
      jQuery('script[src*="agile-store-locator"]').remove().appendTo('html');
      jQuery('<script type="text/javascript" id="agile-store-locator-script-js-extra">/* <![CDATA[ */var ASL_REMOTE = {"ajax_url":"\/wp-admin\/admin-ajax.php","nonce":"1a59b3ac37"};var asl_configuration = {"api_key":"AIzaSyDWwA18uI6Ee3OYnHuat6o-wHVldETgLeg","default_lat":"36.8586","default_lng":"-76.2059","zoom":"11","head_title":"Stores","category_title":"Category","no_item_text":"No Store Found","map_type":"roadmap","distance_unit":"Miles","time_format":"0","cluster":"1","map_language":"","map_region":"US","sort_by":"","display_list":"1","prompt_location":"0","search_destin":"0","geo_button":"0","week_hours":"0","zoom_li":"12","search_zoom":"12","search_type":"0","full_height":"full-height","map_top":"2","full_width":"0","target_blank":"0","scroll_wheel":"0","country_restrict":"US","direction_redirect":"2","URL":"\/wp-content\/plugins\/agile-store-locator\/","map_layout":"[]","words":{"direction":"Directions","zoom":"Zoom","detail":"Website","select_option":"Select Option","search":"Search","all_selected":"All selected","none":"None","none_selected":"None Selected","reset_map":"Reset Map","reload_map":"Scan Area","selected":"selected","current_location":"Current Location","your_cur_loc":"Your Current Location","Miles":"Miles","Km":"Km","phone":"Phone","fax":"Fax","directions":"Directions","distance":"Distance","read_more":"Read more","hide_more":"Hide Details","select_distance":"Select Distance","none_distance":"None","cur_dir":"Current+Location","radius_circle":"Radius Circle"},"version":"1.2.4","days":{"sun":"Sun","mon":"Mon","tue":"Tues","wed":"Wed","thu":"Thur","fri":"Fri","sat":"Sat"}};var asl_categories = {"1":{"id":"1","name":"Arts & Entertainment","icon":"movie-theater.svg"},"2":{"id":"2","name":"For The Home","icon":"home.svg"},"4":{"id":"4","name":"Amusement Park","icon":"amusement-park.svg"},"5":{"id":"5","name":"Medical \/ Dental \/ Vision Care","icon":"hospital.svg"},"6":{"id":"6","name":"Jewelry","icon":"jewelry-store.svg"},"7":{"id":"7","name":"Fitness","icon":"gym.svg"},"8":{"id":"8","name":"Electronics","icon":"electronics-store.svg"},"9":{"id":"9","name":"Pets","icon":"pet-store.svg"},"10":{"id":"10","name":"Auto","icon":"car-repair.svg"},"11":{"id":"11","name":"Local Services","icon":"local-government.svg"},"13":{"id":"13","name":"Beauty and Spas","icon":"spa.svg"},"14":{"id":"14","name":"Nightlife","icon":"night-club.svg"},"16":{"id":"16","name":"Restaurants","icon":"restaurant.svg"},"17":{"id":"17","name":"Travel","icon":"airport.svg"}};var asl_markers = [];/* ]]> */</script>').appendTo('html');
      jQuery('<script type="text/javascript" src="/wp-content/plugins/agile-store-locator/public/js/site_script.js?ver=1.2.4" id="agile-store-locator-script-js"></script>').appendTo('html');
    }
    else {
      jQuery('script[src*="agile-store-locator"]').remove().appendTo('html');
    }
  }
}